<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">見積システム</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="form.quotationNo != null || !valid"
          @click="save"
          v-permit.SHARP_QD_SAVE
          >{{ $t('app.buttons.temporarySave') }}</v-btn
        >
        <v-btn @click="returnToList">{{ $t('app.buttons.back') }}</v-btn>
        <v-btn
          :disabled="form.id == null || !valid"
          @click="quotationCalculate"
          v-permit.SHARP_QD_CALCULATE
          >見積計算</v-btn
        >
        <v-btn
          :disabled="form.quotationNo == null"
          @click="exportCost"
          v-permit.SHARP_QD_NEW_COST
          >コスト計算書作成</v-btn
        >
        <v-btn
          :disabled="form.quotationNo == null"
          @click="exportBook"
          v-permit.SHARP_QD_NEW_QUOTATION
          >見積書作成</v-btn
        >
        <v-btn @click="copyAs" v-if="form.id != null" v-permit.SHARP_QD_CLONE>{{
          $t('app.buttons.toNew')
        }}</v-btn>
        <!-- <v-btn @click="test">test</v-btn> -->
        <v-btn
          :disabled="!form.quotationNo"
          @click="sendMail"
          v-if="form.id != null"
          v-permit.SHARP_QD_MAIL
          >見積書（依頼）メール送信</v-btn
        >
        <!--見積書 功能隐藏-->
        <v-btn v-permit.SHARP_QUOTATION_APPLY @click="applyBook"
          >見積書申請</v-btn
        >
        <v-btn
          v-permit.SHARP_QUOTATION_PUBLISH
          @click="publishBook"
          :disabled="!resData.quotationApply"
          >見積書発行</v-btn
        >
        <v-btn v-permit.SHARP_QUOTATION_DOWNLOAD @click="downloadBook"
          >見積書出力</v-btn
        >
        <v-spacer></v-spacer>
        <v-flex class="quotationNo" md3 style="padding: 0px">
          <v-text-field
            label="見積NO."
            readonly
            style="padding: 0px; margin: 0px"
            v-model="form.quotationNo"
          />
        </v-flex>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-card-title style="padding: 8px">{{
        $t('B0400.titles[1]')
      }}</v-card-title>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                disabled
                key="1"
                label="依頼者"
                url="employees/kv"
                v-model="form.requestById"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!canNew"
                :label="$t('app.labels.bu.name')"
                key="2"
                url="divisions/kv?type=BU"
                v-model="form.headquarterId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!canNew"
                :label="$t('app.labels.partner')"
                key="3"
                url="companies/kv?type=PARTNER"
                v-model="form.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <div required>
                <remote-select
                  :disabled="!canNew"
                  :label="$t('app.labels.transportMode')"
                  :rules="[
                    (v) =>
                      !!v || $t('app.labels.transportMode') + `  is required`,
                  ]"
                  key="7"
                  url="transport-modes/kv"
                  v-model="form.transportModeId"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <div required>
                <remote-select
                  :disabled="!canNew"
                  :key="`4${form.transportModeId}`"
                  :label="$t('app.labels.incoterm')"
                  :rules="[
                    (v) => !!v || $t('app.labels.incoterm') + ` is required`,
                  ]"
                  url="incoterms/kv"
                  item-text="code"
                  v-model="form.incotermId"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <div required>
                <remote-autocomplete
                  :disabled="!canNew"
                  :label="$t('app.labels.loadingPort')"
                  :rules="[
                    (v) => !!v || $t('app.labels.loadingPort') + ` is required`,
                  ]"
                  key="5"
                  url="ports/kv"
                  v-model="form.loadingPortCode"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <div required>
                <remote-autocomplete
                  :disabled="!canNew"
                  :label="$t('app.labels.dischargePort')"
                  :rules="[
                    (v) =>
                      !!v || $t('app.labels.dischargePort') + ` is required`,
                  ]"
                  key="6"
                  url="ports/kv"
                  v-model="form.dischargePortCode"
                />
              </div>
            </v-flex>

            <v-flex md3 sm6 v-if="isSea" xs12>
              <div required>
                <remote-select
                  :disabled="!canNew"
                  :rules="[(v) => !!v || ` 運送方法 is required`]"
                  key="8"
                  label="運送方法"
                  url="stack-types/kv"
                  v-model="form.stackTypeId"
                />
              </div>
            </v-flex>
            <v-flex md3 sm6 v-if="isSea && isFcl" xs12>
              <div required>
                <remote-select
                  :disabled="!canNew"
                  :rules="[(v) => !!v || ` コンテナ情報 is required`]"
                  key="9"
                  label="コンテナ情報"
                  url="container-types/kv"
                  v-model="form.containerTypeId"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <div required>
                <remote-select
                  :disabled="!canNew"
                  :filter="deliveryModeFilter"
                  :rules="[(v) => !!v || ` 搬送サービス is required`]"
                  item-text="ja_JP"
                  item-value="id"
                  key="10"
                  label="搬送サービス"
                  url="charge-item-sub-type"
                  v-model="form.deliveryModelId"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <div required>
                <remote-autocomplete
                  :disabled="!canNew"
                  :rules="[(v) => !!v || ` 納入場所 is required`]"
                  key="11"
                  label="納入場所"
                  url="warehouses/sjl-kv"
                  v-model="form.finallyWarehouseId"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!canAddSupplier"
                :label="$t('app.labels.forwarder')"
                key="12"
                url="companies/forwarders/kv"
                v-model="form.forwarderId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!canAddSupplier"
                :label="$t('app.labels.customsAgent')"
                key="13"
                url="companies/customs/kv"
                v-model="form.customsDirectorId"
              />
            </v-flex>
            <v-flex xs3>
              <div required>
                <remote-autocomplete
                  :disabled="!canNew"
                  :rules="[(v) => !!v || ` 貨物タイプ is required`]"
                  key="14"
                  label="貨物タイプ"
                  url="commodity-types/kv"
                  v-model="form.commodityTypeId"
                />
              </div>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!canAddSupplier"
                :filter="(p) => p.code !== 'WAREHOUSE_TRANSPORT'"
                key="14-2"
                label="Speical"
                url="specials/kv"
                v-model="form.specialId"
              />
            </v-flex>
            <v-flex xs3>
              <div required>
                <date-picker
                  :rules="[(v) => !!v || ` 納入予定日 is required`]"
                  label="納入予定日"
                  v-model="form.forecastDeliveryDate"
                ></date-picker>
              </div>
            </v-flex>
            <v-flex v-if="isCharter" xs3>
              <div required>
                <remote-autocomplete
                  :disabled="!canNew"
                  :rules="[(v) => !!v || ` ﾁｬｰﾀｰﾄﾗｯｸ種別 is required`]"
                  key="15"
                  label="ﾁｬｰﾀｰﾄﾗｯｸ種別"
                  url="truck-types/kv"
                  v-model="form.truckTypeId"
                />
              </div>
            </v-flex>
            <!-- <v-flex v-if="isAir" xs3>
              <v-text-field :readonly="true" :value="form.quotationCw" label="c/w"></v-text-field>
            </v-flex>-->

            <v-flex xs3>
              <v-text-field
                :disabled="true"
                clearable
                key="16"
                label="有効期限"
                v-model="form.validPeriod"
              />
            </v-flex>
            <v-flex xs3>
              <div required>
                <v-select
                  :items="['有償', '無償']"
                  :rules="[(v) => !!v || ` 有無償 is required`]"
                  clearable
                  key="17"
                  label="有無償"
                  v-model="form.paidType"
                  v-if="!isDapDdp"
                ></v-select>

                <v-select
                  :items="['無償']"
                  :rules="[(v) => !!v || ` 有無償 is required`]"
                  clearable
                  key="18"
                  label="有無償"
                  v-model="form.paidType"
                  v-if="isDapDdp"
                ></v-select>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <routing
      :detail="form"
      @change="onRouteChanged"
      class="mt-2"
      v-if="1 !== 1"
    />
    <cargo-list :canEdit="canNew" :quotation="form" ref="cargoList" />
    <!-- <quotation-list :form="form" :!canNew="!canNew" ref="quotationList"/> -->
    <v-card class="mt-2">
      <v-card-actions>
        <v-btn @click="editCharges()" :disabled="chargeEdit">編集</v-btn>
        <v-btn @click="cancelEditCharges()" :disabled="!chargeEdit">戻る</v-btn>
        <v-btn @click="saveEditedCharges()" :disabled="!chargeEdit">保存</v-btn>
      </v-card-actions>
      <v-card-text>
        <!-- <list-total-charges
          :hideAdditionalCharges="true"
          :canAdjust="canAdjust"
          :shipment="form"
          class="mt-2"
          columns="0,13,2,4,14,1,5,6,7,9,10,11"
          :columnHeaders="{ 0: '計算費用項目', 1: '外貨小計', 5: '円価' }"
          ignoreSupplier
          ref="requestArea"
          scope="0"
        /> -->
        <list-total-charges
          :columnHeaders="{ 1: '金額', 6: '調整金額', 7: '調整後金額' }"
          :canAdjust="canAdjust"
          :shipment="form"
          class="mt-2"
          columns="0,1,2,4,5,6,7"
          ignoreSupplier
          ref="requestArea2"
        />
        <!-- <list-charges
          :shipment="form"
          columns="0,1,2,3,19"
          hide-additional-charges
          scope="3"
        /> -->
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-text>
        <edit-charges
          :exchangeRateDate="new Date().format('yyyy-MM-dd')"
          :shipment="form"
          :taxDate="new Date().format('yyyy-MM-dd')"
          columns="0,1,5,2,3,14,8"
          exchangeRateScope="INTERNAL"
          scope="3"
        />
      </v-card-text>
    </v-card>
    <bill-cost-table :quotation="form" class="mt-2" ref="costTable" />
    <document-dialog @doEvent="doEvent" ref="docDlg" />
    <employee-dialog
      :employees="employee"
      ref="employeeDialog"
    ></employee-dialog>
    <update-sjl-approval-no-dialog
      ref="approvalNo"
    ></update-sjl-approval-no-dialog>
  </v-container>
</template>

<script>
import CargoList from './CargoList'
// import QuotationList from "./QuotationList";
import Routing from '../B0601/Routing'
import BillCostTable from './BillCostTable'
import DocumentDialog from './DocumentDialog'
import EmployeeDialog from './EmployeeDialog'
import UpdateSjlApprovalNoDialog from './UpdateSjlApprovalNoDialog'

export default {
  components: {
    CargoList,
    BillCostTable,
    Routing,
    DocumentDialog,
    EmployeeDialog,
    UpdateSjlApprovalNoDialog,
  },
  data() {
    return {
      chargeEdit: false,
      valid: false,
      employee: [],
      resData: {},
      form: {
        commodityTypeId: 'COMMODITY_TYPE-GENERAL',
        shipmentType: 'QUOTATION',
        items: [],
        incotermId: null,
        routes: [],
        otherCharge1: null,
        otherCharge2: null,
        transportModeId: null,
      },
      allLoadingDisplayPort: [],
      loadingDisplayPort: [],
      loadingPort: [],
      dischargePort: [],
      allDischargeDisplayPort: [],
      dischargeDisplayPort: [],
      displayWarehouse: [],
      warehouse: [],
      route: [],
    }
  },
  mounted() {
    this.form = this.$route.params.quotation || this.form
  },
  methods: {
    editCharges() {
      this.chargeEdit = true
    },
    saveEditedCharges() {
      this.chargeEdit = false
      console.log('save edited charges')
      var value = this.form.charges
        .filter((i) => i.adjustable == true)
        .map((c) => {
          return {
            // id: c.id,
            shipmentId: c.shipmentId,
            chargeItemId: c.chargeItemId,
            containerTypeCode: c.containerTypeCode,
            subTotalAdjust: c.subTotalAdjust,
            paymentSubTotalAdjust: c.paymentSubTotalAdjust,
            comment: c.comment,
          }
        })
      this.$http
        .put('/delivery-orders/adjust-value?token=subTotalAdjust', value)
        .then(() => {
          this.$http.put(`/shipping-advices/${this.form.id}/calc-insurance`)
        })
        .then(() => {
          this.reloadCalcCharges()
        })
    },
    cancelEditCharges() {
      this.chargeEdit = false
      this.reloadCalcCharges()
    },
    reloadCalcCharges() {
      this.$http.get(`/quotations/${this.$route.query.id}`).then((res) => {
        this.form.charges = [
          ...this.form.charges.filter((charge) =>
            ['LOCAL-024', 'LOCAL-025'].includes(charge.chargeItemCode)
          ),
          ...res.data.charges.filter(
            (charge) =>
              !['LOCAL-024', 'LOCAL-025'].includes(charge.chargeItemCode)
          ),
        ]
      })
    },
    canAdjust(charge) {
      return this.chargeEdit
    },

    doEvent(btn) {
      eval('this.' + btn.event + '()')
    },
    test() {
      this.$http.get('/pricings/port').then((res) => {
        res.data.forEach((r) => {
          this.allLoadingDisplayPort.push(r[0])

          this.allDischargeDisplayPort.push(r[2])
        })

        for (var i = 0; i < this.allLoadingDisplayPort.length; i++) {
          if (
            this.loadingDisplayPort.indexOf(this.allLoadingDisplayPort[i]) == -1
          ) {
            this.loadingDisplayPort.push(this.allLoadingDisplayPort[i])
          }
        }

        for (var j = 0; j < this.allDischargeDisplayPort.length; j++) {
          if (
            this.dischargeDisplayPort.indexOf(
              this.allDischargeDisplayPort[j]
            ) == -1
          ) {
            this.dischargeDisplayPort.push(this.allDischargeDisplayPort[j])
          }
        }

        this.route = res.data

        this.loadingDisplayPort.forEach((l) => {
          let port = res.data.find((all) => all[0] === l)
          this.loadingPort.push({
            code: port[0],
            name: port[1],
            displayName: port[0] + ':' + port[1],
          })
        })

        this.dischargeDisplayPort.forEach((d) => {
          let port = res.data.find((all) => all[2] === d)
          this.dischargePort.push({
            code: port[2],
            name: port[3],
            displayName: port[2] + ':' + port[3],
          })
        })
      })
    },
    exportCost() {
      this.$refs.docDlg.popup('輸入コスト試算書', this.resData, [
        {
          name: 'SAVE AS PDF',
          event: 'save',
        },
        {
          name: '戻る',
          event: 'back',
        },
      ])
    },
    exportBook() {
      this.$refs.docDlg.popup('概算見積書', this.resData, [
        {
          name: 'SAVE AS PDF',
          event: 'save',
        },
        {
          name: '戻る',
          event: 'back',
        },
      ])
    },
    applyBook() {
      this.$refs.docDlg.popup(
        '概算見積書',
        this.resData,
        [
          {
            name: '決裁番号入力',
            event: 'inputNo',
            disabled: this.resData.quotationApply,
          },
          {
            name: '申請',
            event: 'apply',
            disabled: this.resData.quotationApply,
          },
          {
            name: '戻る',
            event: 'back',
            disabled: false,
          },
        ],
        true
      )
    },
    apply() {
      this.$http.put(`/quotations/apply/${this.resData.id}`).then(() => {
        this.$message('', 'SUCCESS')
        this.load()
        this.$refs.docDlg.close()
      })
    },
    inputNo() {
      this.$refs.approvalNo.popup(this.resData)
    },
    publishBook() {
      this.$refs.docDlg.popup(
        '概算見積書',
        this.resData,
        [
          {
            name: '見積書確認',
            event: 'publish',
            disabled: this.resData.quotationPublish,
          },
          {
            name: '戻る',
            event: 'back',
            disabled: false,
          },
        ],
        true
      )
    },
    publish() {
      this.$http.put(`/quotations/publish/${this.resData.id}`).then(() => {
        this.$message('', 'SUCCESS')
        this.load()
        this.$refs.docDlg.close()
      })
    },
    downloadBook() {
      this.$refs.docDlg.popup(
        '概算見積書',
        this.resData,
        [
          {
            name: 'SAVE AS PDF',
            event: 'save',
          },
          {
            name: '戻る',
            event: 'back',
          },
        ],
        true
      )
    },

    returnToList() {
      this.$router.push({
        path: '/B0200',
      })
    },
    save() {
      this.$http
        .post('/quotations', {
          ...this.form,
          importCost: this.importCost,
          estimatePrice: this.estimatePrice,
        })
        .then((res) => {
          this.$message('', this.$t('app.messages.saveSuccess'))
          this.$router.push({
            path: '/B0201/edit',
            query: { id: res.data.id },
          })
        })
        .catch()
    },
    load() {
      this.$http.get('/currencies/all').then((currencies) => {
        this.$http.get(`/quotations/${this.$route.query.id}`).then((res) => {
          this.resData = res.data
          this.form = { ...this.form, ...res.data }
          this.form.items = this.form.items.map((item, idx) => {
            item.seq = new Date().getTime() + idx
            item.currencyRate = item.isCurrencyRateHandwrite
              ? item.currencyRate
              : this.$getCurrencyRate(
                  currencies.data.find(
                    (currency) => currency.code === item.currencyCode
                  ),
                  'INTERNAL',
                  new Date().format('yyyy-MM-dd')
                )
            return item
          })
          this.form.otherCharge1 = this.findOtherCharge('その他費用１')
          this.form.otherCharge2 = this.findOtherCharge('その他費用２')
        })
      })
    },
    findOtherCharge(name) {
      let otherChargeGroup = this.form.charges.filter(
        (i) => i.chargeItemName == name
      )

      return 0 //otherChargeGroup && otherChargeGroup[0].jpySubTotal
    },
    findCurrentUser() {
      var employee = JSON.parse(localStorage.getItem('currentEmployee'))
      this.form.requestById = employee.id
    },
    hasJpySubTotal(charge) {
      return charge.jpySubTotal != null && charge.jpySubTotal > 0
    },
    isFreight(charge) {
      return 'AIR-002,SEA-001'.indexOf(charge.chargeItemCode) !== -1
    },
    isFreightZeroHasFound(charges) {
      let arr = charges.filter(
        (i) => this.isFreight(i) && !this.hasJpySubTotal(i)
      )
      if (arr && arr.length > 0) {
        return true
      }
      return false
    },
    isLocalDelivery(charge) {
      return (
        'LOCAL-001,LOCAL-002,LOCAL-003'.indexOf(charge.chargeItemCode) !== -1
      )
    },
    isLocalDeliveryZero(charges) {
      let arr = charges.filter(
        (i) => this.isLocalDelivery(i) && !this.hasJpySubTotal(i)
      )
      if (arr && arr.length > 0) {
        return true
      }
      return false
    },
    quotationCalculate() {
      this.$http
        .put(`/quotations/${this.form.id}/calc`, this.form)
        .then((res) => {
          this.$message('', this.$t('B200.messages.quotationSuccess'))
          if (this.isFreightZeroHasFound(res.data.charges)) {
            console.log('TODO', 'charge Freight has not found')
          } else if (this.isLocalDeliveryZero(res.data.charges)) {
            console.log('TODO', 'charge 国内运货 has not found')
          }
          this.load()
        })
        .catch(this.catch)
    },
    catch(res) {
      if (res.response.status === 500) {
        if (res.response.data.message == 'DO_HAS_CONFIRMED') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B1000.messages.errors.doHasConfirmed')
          )
        } else if (res.response.data.message == 'BL_NO_DUPLICATE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0400.messages.errors.invalidBlNo')
          )
        } else if (res.response.data.message == 'EXCHANGE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.exchangeRateNotFoundForQuotation')
          )
        } else if (res.response.data.message == 'PRICING_REPEAT') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '単価に重複レコードがあります'
          )
        } else if (res.response.data.message == 'PRICING_PAYMENT_PRICE_WRONG') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '支払い単価が設定されていません'
          )
        } else if (res.response.data.message == 'EXCHANGE_RATE_DATE_REPEAT') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '為替レート日付の繰り返し'
          )
        } else if (res.response.data.message == 'VALUE_CHARGE_ZERO') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '商品金額JPYを0にすることはできません'
          )
        } else if (
          res.response.data.message.indexOf('PRICING_NOT_FOUND') !== -1
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.pricingNotFoundForQuotation', {
              chargeItem: res.response.data.message.split(';')[1],
            })
          )
        } else if (res.response.data.message == 'INSURANCE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.insuranceRateNotFoundForQuotation')
          )
        } else if (res.response.data.message == 'TAX_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.taxRateNotFoundForQuotation')
          )
        } else if (res.response.data.message == 'COMMISSION_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.commissionRateNotFoundForQuotation')
          )
        } else {
          this.$message(
            this.$t('app.messages.errors.title'),
            `system error, module:${this.$route.path}`
          )
        }
      }
    },
    onRouteChanged(detail) {
      this.form = detail
    },
    sendMail() {
      this.$http.get(`quotations/${this.form.id}/checkEmail`).then((res) => {
        let employees = res.data
        if (employees.length > 0) {
          this.$http.put(`/quotations/${this.form.id}/send-mail`).then(() => {
            this.employee = res.data
            this.$refs.employeeDialog.popup()
            this.selected = []
            this.load()
          })
        } else {
          this.$message('', '送信先が登録されていないため、ご確認ください。')
        }
      })
      // this.$http.put(`/quotations/${this.form.id}/send-mail`).then(() => {
      //   this.$message('', this.$t('app.messages.sent', { type: '' }))
      //   this.load()
      // })
    },
  },
  computed: {
    isDapDdp() {
      return (
        this.form &&
        this.form.incotermId &&
        (this.form.incotermId === 'INCOTERM-DAP' ||
          this.form.incotermId === 'INCOTERM-DDP')
      )
    },
    currentUserId() {
      return this.$store.getters.user
    },
    canNew() {
      return (
        this.$store.getters.user.functions.filter(
          (r) => r.code === 'SHARP_QS_NEW'
        ).length > 0
      )
    },
    canAddSupplier() {
      return (
        this.$store.getters.user.roles.filter(
          (r) => r.roleCode.indexOf('_SJL_') !== -1
        ).length > 0
      )
    },
    isSea() {
      return this.$isSea(this.form.transportModeId)
    },
    isAir() {
      return this.$isAir(this.form.transportModeId)
    },
    isCharter() {
      return this.form.deliveryModelId == 'CHARGE_ITEM_SUB_TYPE-CHARTER'
    },
    isLcl() {
      return this.form.stackTypeId == 'STACK_TYPE-LCL'
    },
    isFcl() {
      return this.form.stackTypeId == 'STACK_TYPE-FCL'
    },
    deliveryModeFilter() {
      if (this.isAir) {
        return (i) => i.isCharter || i.isMixLoading
      }
      if (this.isSea) {
        if (this.isFcl) {
          return (i) => i.isDrake
        }
      }
      return (i) => i.isDelivery
    },
  },
  watch: {
    'form.loadingPortCode'() {
      this.route
        .filter((r) => r[0] == this.form.loadingPortCode)
        .forEach((r) => {
          this.dischargePort = []
          this.dischargePort.push({
            code: r[2],
            name: r[3],
            displayName: r[2] + ':' + r[3],
          })
          this.warehouse = []
          this.warehouse.push({
            id: r[4],
            code: r[5],
            name: r[6],
            displayName: r[5] + ':' + r[6],
          })
        })
    },
    'form.dischargePortCode'() {
      this.route
        .filter((r) => r[2] == this.form.dischargePortCode)
        .forEach((r) => {
          this.loadingPort = []
          this.loadingPort.push({
            code: r[0],
            name: r[1],
            displayName: r[0] + ':' + r[1],
          })
          this.warehouse = []
          this.warehouse.push({
            id: r[4],
            code: r[5],
            name: r[6],
            displayName: r[5] + ':' + r[6],
          })
        })
    },
    'form.transportModeId'() {
      if (this.isAir) {
        this.form.stackTypeId = null
        this.form.containerTypeId = null
      }
    },
    'form.deliveryModelId'() {
      if (!this.isCharter) {
        this.form.truckTypeId = null
      }
    },
    'form.stackTypeId'() {
      if (this.isLcl) {
        this.form.containerTypeId = null
      }
    },
  },
  created() {
    this.findCurrentUser()
  },
}
</script>
<style scoped>
.quotationNo {
  padding: 0px;
}
.quotationNo /deep/ .v-input__slot {
  margin: 0px;
}
</style>
